import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { EditorService } from "../services/editor.service";
import { Subject, takeUntil } from "rxjs";
import { EditorCanvasComponent } from "../editor-canvas/editor-canvas.component";

@Component({
  selector: 'app-measurement-control-window',
  templateUrl: './measurement-control-window.component.html',
  styleUrls: ['./measurement-control-window.component.css']
})
export class MeasurementControlWindowComponent implements OnInit, OnDestroy {
  @Output() measurementFeatureStateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() editorCanvasComponent: EditorCanvasComponent;
  measurementFeatureActive: boolean = false;
  enableMeasurementFunction: boolean = false;
  enableSnappingFunction: boolean = false;
  enableFreeDrawingFunction: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private editorService: EditorService) {
  }

  ngOnInit(): void {
    this.editorService.measurementFunctionState.pipe(takeUntil(this.unsubscribe$)).subscribe((state: boolean) => {
      this.enableMeasurementFunction = state;
    });

    this.editorService.snappingFunctionState.pipe(takeUntil(this.unsubscribe$)).subscribe((state: boolean) => {
      this.enableSnappingFunction = state;
    });

    this.editorService.freeDrawingFunctionState.pipe(takeUntil(this.unsubscribe$)).subscribe((state: boolean) => {
      this.enableFreeDrawingFunction = state;
    });
  }

  setMeasurementFeatureActiveState() {
    this.measurementFeatureActive = !this.measurementFeatureActive;
    this.measurementFeatureStateChanged.emit(this.measurementFeatureActive);
  }

  getDeleteDisabledState() {
    if (this.editorCanvasComponent === undefined || this.editorCanvasComponent.stage === undefined) {
      return true;
    }
    let result = this.editorCanvasComponent.stage.find('.measurement-group');

    return result.length === 0;
  }

  deleteMeasurements() {
    this.editorCanvasComponent.stage.find('.measurement-group').forEach(g => g.destroy());
  }

  setMeasurementFunctionState() {
    this.editorService.setMeasurementFunctionState(!this.enableMeasurementFunction);
  }

  setSnappingFunctionState() {
    this.editorService.setSnappingFunctionState(!this.enableSnappingFunction);
  }

  setFreeDrawingFunctionState() {
    this.editorService.setFreeDrawingFunctionState(!this.enableFreeDrawingFunction);
    if (this.enableSnappingFunction) {
      this.editorService.setSnappingFunctionState(!this.enableSnappingFunction);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}